import { isInStandaloneMode } from '../../../sw/util';

export const VERSION_CHECK_INTERVAL = (isInStandaloneMode ? 2 : 5) * 60_000;
export const KYC_CHECK_INTERVAL = 5 * 60_000;
export const KYC_CHECK_INTERVAL_SHORT = 30_000;
export const KYC_PUSH_INTERVAL_MINS = 60 * 24;
export const KYC_2ND_PUSH_INTERVAL = 60_000;
export const KYC_PASSED_CHECK_INTERVAL = 4 * 60 * 60_000;
export const MIN_BALANCE_TO_CREATE_SERVICE = 100;
export const SUBSCRIPTIONS_CHECK_INTERVAL = 60 * 60_000;
export const INVESTMENT_STATUS_INTERVAL = 20_000;
export const KYC_EXPIRY_WARNING_DAYS = 14;
export const KYC_HOW_MANY_MINUTES_TO_START =
  (KYC_CHECK_INTERVAL * 2.1) / 60_000;
